// F17: the property form stores one optional rate step as flat fields
// (mortgage_step_after_years / mortgage_step_rate_pct, D1 columns) and the
// "fee added to loan" flag as 0/1. The engine takes mortgage_rate_steps as a
// list of {after_years, rate_pct} and a boolean flag.

export function toEngineMortgage<T extends Record<string, any>>(p: T): Record<string, any> {
  const { mortgage_step_after_years, mortgage_step_rate_pct, ...rest } = p as Record<string, any>;
  const after = Number(mortgage_step_after_years) || 0;
  return {
    ...rest,
    mortgage_rate_steps: after > 0
      ? [{ after_years: after, rate_pct: Number(mortgage_step_rate_pct) || 0 }]
      : [],
    mortgage_fee_added_to_loan: Boolean(Number(p.mortgage_fee_added_to_loan) || p.mortgage_fee_added_to_loan === true),
  };
}
